import HttpClient from 'httpClient/index';
import type { DataCity } from 'common/dataService/types/countriesTypes';

const BASE_URL = `${process.env.REACT_APP_DATA_API || ''}/api/datacities`;

class DataServiceDataCities extends HttpClient {
  public constructor() {
    super(BASE_URL);
  }

  public getDataCities = (countryCode: string): Promise<DataCity[]> =>
    this.instance.get('', { params: { countryCode } });

  public createDataCity = (body: { name: string; countryCode: string }): Promise<DataCity> =>
    this.instance.post('', body);

  public updateDataCity = (body: { id: number; name: string; countryCode: string }): Promise<DataCity> =>
    this.instance.put('', body);

  public deleteDataCity = (id: number): Promise<void> => this.instance.delete(`/${id}`);
}

export default new DataServiceDataCities();
